import React from "react";
import { NavigationConcept } from "./pages/NavigationConcept";
export function App() {
  return <NavigationConcept data-id="element-0" data-mp="35ctt9as4y9f6" />;
}